import { connect } from 'react-redux';
import {
    fetchValidateAccreditation,
    getAccreditationDataFormatted,
    getCurrentAccreditationId,
    loadingAccreditationList,
    cleanValidatedStatus,
    cleanStartAccreditation,
    setNextAsStartAccreditationForValidation, loadingManagedOrgs, getManagedOrgsOptions, fetchGetManagedOrgs
} from '../../../reducers/accreditation/accreditations';
import ValidateAccreditation from './ValidateAccreditation';
import {
    getCurrentContinent,
    setCurrentContinent,
    getCountriesData,
    getContinentsData,
    getLocationData
} from '../../../reducers/common/location';
import { fetchGetLevels, getLevelsData } from '../../../reducers/common/levels';
import { getTranslation } from "../../../reducers/common/localization";
import {setCurrentContinentByCountry} from "../../../reducers/common/location";
import {MODAL_VALIDATE_ACCREDITATION, showModal} from "../../../reducers/common/activeModal";
import {isOrgBava} from '../../../reducers/organization/organization';

const mapStateToProps = state => {
    return {
        id: getCurrentAccreditationId(state),
        loading: loadingAccreditationList(state),
        data: getAccreditationDataFormatted(state),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        levels: getLevelsData(state),
        translation: getTranslation(state),
        isBava: isOrgBava(state),
        loadingManagedOrgs: loadingManagedOrgs(state),
        managedOrgs: getManagedOrgsOptions(state),
        locationData: getLocationData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSubmit: (id, data) => {
            dispatch(fetchValidateAccreditation(id, data));
        },
        onContinentSetByCountry: (countryCode) => {
            dispatch(setCurrentContinentByCountry(countryCode));
        },
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onGetLevels: () => {
            dispatch(fetchGetLevels());
        },
        onUnmount: () => {
            dispatch(cleanValidatedStatus());
            dispatch(cleanStartAccreditation());
        },
        onNext: () => {
            dispatch(setNextAsStartAccreditationForValidation());
        },
        onOpenValidateAccreditationModal: () => dispatch(showModal({modalKey: MODAL_VALIDATE_ACCREDITATION})),
        onGetManagedOrgs: (countryCode) => {
            dispatch(fetchGetManagedOrgs(countryCode));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidateAccreditation);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/validateAccreditation/ValidateAccreditation.container.js